import React from 'react';
import styles from './Productos.module.css';
import { useScrollAnimation } from '../../../ganchos/usarAnimacionScroll';
import logoFull from '../../../recursos/imagenes/logo.webp';
import { OrbeInteractivo } from '../../UI/OrbeInteractivo';
import TopCategorias from './TopCategorias';

export const ProductsSection = () => {
  const [ref, visible] = useScrollAnimation({ threshold: 0.08 });
  return (
    <section id="products" ref={ref} className={`${styles.seccion} ${visible ? styles.visible : ''}`}>
      <div className="container">
        <div className={styles.encabezado}>
          <h2 className={styles.tituloBloque}>
            <span className={styles.tituloTexto}>Productos</span>
            <img src={logoFull} alt="SEIMA" className={styles.logoTitulo} />
          </h2>
          <div className={`${styles.lineaTitulo} ${visible ? styles.lineaVisible : ''}`} />
          <p className={styles.sub}>Descubre la solución más adecuada para tu industria seleccionando lo que necesitas lograr.</p>
        </div>
        
        {/* Nuevo Orbe Interactivo */}
        <OrbeInteractivo />

        {/* Top Categories Extension */}
        <TopCategorias />
      </div>
    </section>
  );
};
export default ProductsSection;
